import { createContext, useContext, useMemo, type ReactNode } from "react";

export type MenuNavigationContextValue = {
  gradeId: number | null;
  examIds: readonly number[];
  verticalId: number | null;
  isdCode: string | null;
};

const MenuNavigationContext = createContext<MenuNavigationContextValue | null>(
  null,
);

export function MenuNavigationContextProvider({
  gradeId,
  examIds,
  verticalId,
  isdCode,
  children,
}: {
  gradeId: number | null;
  examIds: readonly number[];
  verticalId?: number | null;
  isdCode?: string | null;
  children: ReactNode;
}) {
  const examKey = examIds.join(",");
  const value = useMemo<MenuNavigationContextValue>(
    () => ({
      gradeId,
      examIds: examIds.length ? [...examIds] : [],
      verticalId: verticalId ?? null,
      isdCode: isdCode ?? null,
    }),
    [gradeId, examKey, verticalId, isdCode],
  );

  return (
    <MenuNavigationContext.Provider value={value}>
      {children}
    </MenuNavigationContext.Provider>
  );
}

export function useMenuNavigationProgram(): MenuNavigationContextValue {
  return (
    useContext(MenuNavigationContext) ?? {
      gradeId: null,
      examIds: [],
      verticalId: null,
      isdCode: null,
    }
  );
}
